import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { Fragment } from 'react';
import { OrderedMap, Map } from 'immutable';

var TextInput = function TextInput(props) {
  return /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: props.id || props.name,
    name: props.name,
    value: props.value || '',
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus
  });
};

var CheckboxInput = function CheckboxInput(props) {
  return /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: props.id || props.name,
    name: props.name,
    checked: props.value || false,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus
  });
};

export var TableLayout = function TableLayout(_ref) {
  var rows = _ref.rows,
      onAdd = _ref.onAdd,
      options = _ref.options;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, options.toIndexedSeq().toList().map(function (config) {
    return /*#__PURE__*/React.createElement("th", {
      key: config.get('name')
    }, config.get('label'));
  }), /*#__PURE__*/React.createElement("th", null, "\xA0"))), /*#__PURE__*/React.createElement("tbody", null, rows)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onAdd
  }, "Add"));
};

var RowLayout = function RowLayout(_ref2) {
  var fields = _ref2.fields,
      onDelete = _ref2.onDelete;
  return /*#__PURE__*/React.createElement("tr", null, fields.map(function (field, name) {
    return /*#__PURE__*/React.createElement("td", {
      key: name
    }, field);
  }).toList(), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onDelete
  }, "Delete")));
};

var typeToComponent = {
  text: 'TextInput',
  checkbox: 'CheckboxInput'
};
var defaultComponents = {
  TableLayout: TableLayout,
  RowLayout: RowLayout,
  TextInput: TextInput,
  CheckboxInput: CheckboxInput
};

var fieldFromConfig = function fieldFromConfig(config) {
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return components[typeToComponent[config.get('type')]] || components['TextInput'];
};

export var TableInput = function TableInput(props) {
  var _props$components = props.components,
      components = _props$components === void 0 ? {} : _props$components,
      options = props.options,
      rows = props.rows,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus;

  var appliedComponents = _objectSpread(_objectSpread({}, defaultComponents), components);

  var RowLayout = appliedComponents.RowLayout,
      TableLayout = appliedComponents.TableLayout;

  var handleAddRow = function handleAddRow(e) {
    e.preventDefault();
    var newRow = options.reduce(function (row, config) {
      return row.set(config.get('name'), config.get('type') === 'checkbox' ? false : '');
    }, Map());
    onChange(rows.push(newRow));
  };

  var fieldRows = props.rows.map(function (row, index) {
    var handleDeleteRow = function handleDeleteRow(e) {
      e.preventDefault();
      onChange(rows["delete"](index));
    };

    var fields = options.reduce(function (fields, config) {
      var Field = fieldFromConfig(config, appliedComponents);
      var value = row.get(config.get('name'));

      var handleChangeField = function handleChangeField(e) {
        var value = config.get('type') === 'checkbox' ? e.target.checked : e.target.value;
        return onChange(rows.setIn([index, config.get('name')], value));
      };

      return fields.set(config.get('name'), /*#__PURE__*/React.createElement(Field, {
        value: value,
        onChange: handleChangeField,
        label: config.get('label'),
        onBlur: onBlur,
        onFocus: onFocus
      }));
    }, OrderedMap());
    return /*#__PURE__*/React.createElement(RowLayout, {
      key: index,
      fields: fields,
      options: options,
      onDelete: handleDeleteRow
    });
  });
  return /*#__PURE__*/React.createElement(TableLayout, {
    rows: fieldRows,
    onAdd: handleAddRow,
    options: options
  });
};